import React, { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";

const TextDetectionPopup = ({
  isOpen,
  onClose,
  title,
  hrTexts,
  technicalTexts,
  codingTexts,
  mockTestTexts,
  isJobPost,
}) => {
  const [activeTab, setActiveTab] = useState("hr"); // 'hr' or 'technical'
  useEffect(() => {
    if (hrTexts.length > 0) {
      setActiveTab("hr");
    } else if (technicalTexts.length > 0) {
      setActiveTab("technical");
    } else if (codingTexts.length > 0) {
      setActiveTab("coding");
    } else if (mockTestTexts.length > 0) {
      setActiveTab("mockTest");
    }
  }, [hrTexts, technicalTexts, codingTexts, mockTestTexts]);
  
  if (!isOpen) return null;

  const currentTexts = activeTab === "hr" ? hrTexts : activeTab === "technical" ? technicalTexts : activeTab === "coding" ? codingTexts : mockTestTexts;

  const switchToHr = () => {
    setActiveTab("hr");
  };

  const switchToTechnical = () => {
    setActiveTab("technical");
  };

  const switchToCoding = () => {
    setActiveTab("coding");
  };

  const switchToMockTest = () => {
    setActiveTab("mockTest");
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg w-[90%] max-w-4xl max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-xl font-semibold">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <IoClose size={24} />
          </button>
        </div>

        {/* Tab Buttons */}
        {isJobPost && (
        <div className="flex gap-4 px-4 pt-4">
          {hrTexts?.length > 0 && (
            <button
              onClick={switchToHr}
              className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                activeTab === "hr"
                  ? "bg-primary text-white"
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200"
              }`}
            >
              HR Interview ({hrTexts.length})
            </button>
          )}
          {technicalTexts?.length > 0 && (
            <button
              onClick={switchToTechnical}
              className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                activeTab === "technical"
                  ? "bg-primary text-white"
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200"
              }`}
            >
              Technical Interview ({technicalTexts.length})
            </button>
          )}
          {codingTexts?.length > 0 && (
            <button
              onClick={switchToCoding}
              className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                activeTab === "coding"
                  ? "bg-primary text-white"
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200"
              }`}
            >
              Coding Interview ({codingTexts.length})
            </button>
          )}
          {mockTestTexts?.length > 0 && (
            <button
              onClick={switchToMockTest}
              className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                activeTab === "mockTest"
                  ? "bg-primary text-white"
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200"
              }`}
            >
              MCQ Test ({mockTestTexts.length})
            </button>
          )}
        </div>
        )}
        {/* Text Content */}
        <div className="p-4 overflow-y-auto max-h-[60vh]">
          <div className="space-y-4">
            {currentTexts?.map((text, index) => (
              <div key={index} className="bg-gray-50 p-4 rounded-lg">
                <div className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-red-100 flex items-center justify-center">
                    <span className="text-red-600 font-medium">
                      {index + 1}
                    </span>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-base font-medium text-gray-800 mb-2">
                      {text.label}
                    </h3>
                    <p className="text-sm text-gray-600 whitespace-pre-wrap">
                      {text.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextDetectionPopup;
